<template>
  <div class="page-404">
    <div class="page-404-content">
      <img src="@/assets/images/icon-404.png" alt="">
      <h6>AH OH~  页面找不到了！</h6>
      <p>也许探索AI知识之路，有时会迷航，但请相信，勿忘初心，</p>
      <p>我们终将会抵达梦想的彼岸~</p>
    </div>
    <div class="return-button" @click="returnHome">返回首页</div>
  </div>
</template>

<script>
export default {
  // name: '404',
  components: {},
  props: {},
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {
    returnHome() {
      this.$router.push({name: 'home'});
    }
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.page-404 {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background: url('~@/assets/images/background-404.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .page-404-content {
    color: #EBF1FF;
    font-family: OPPOSans;
    text-shadow: 0 0 20px #EBF1FF;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 557px;
      height: 388px;
    }
    h6 {
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 30px;
      line-height: 52px;
      letter-spacing: 5px;
    }
    p {
      font-size: 18px;
      line-height: 36px;
      letter-spacing: 3px;
    }
  }
  .return-button {
    width: 180px;
    height: 56px;
    color: #ABB0BE;
    font-size: 16px;
    font-family: OPPOSans;
    border: 1px solid rgba($color: #ABAFBE, $alpha: 0.7);
    box-shadow: 0 0 5px rgba($color: #ABAFBE, $alpha: 0.5);
    border-radius: 28px;
    text-shadow: 0 0 20px #EBF1FF;
    text-align: center;
    line-height: 56px;
    margin-top: 100px;
    cursor: pointer;
    &:hover {
      color: #EBF1FF;
      border: 1px solid #ABAFBE;
    }
  }
}
</style>
